import { RouteRecordRaw } from "vue-router"

export const recordRoutes: RouteRecordRaw[] = [
	{
		path: "/writeDairy",
		name: "writeDairy",
		component: () => import("@/views/record/writeDairy.vue")
	},
	{
		path: "/uploadPicturePage",
		name: "uploadPicturePage",
		component: () => import("@/views/record/uploadPicturePage.vue")
	},
	{
		path: "/uploadVideoPage",
		name: "uploadVideoPage",
		component: () => import("@/views/record/uploadVideoPage.vue")
	},
	{
		path: "/dairyDetail",
		name: "dairyDetail",
		component: () => import("@/views/record/dairyDetail.vue")
	},
	{
		path: "/videoDetail",
		name: "videoDetail",
		component: () => import("@/views/record/videoDetail.vue")
	},
	{
		path: "/test",
		name: "Test",
		component: () => import("@/views/record/test.vue")
	},
]
